import { useNavigate, Link } from "react-router-dom";
import { FaBinoculars, FaArrowLeft, FaHome } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const NotFound: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-6 text-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-brand-50 text-brand-400">
                <FaBinoculars className="h-10 w-10" />
            </div>

            <h1 className="mt-8 text-7xl font-extrabold tracking-tight text-brand-gray sm:text-8xl">
                404
            </h1>
            <span className="mx-auto my-6 block h-1 w-16 rounded-full bg-brand-400" />

            <p className="max-w-md text-lg text-gray-600">
                {t('notFound')}
            </p>

            <div className="mt-10 flex items-center gap-4">
                <button
                    onClick={() => navigate(-1)}
                    aria-label="Go back"
                    className="flex h-11 w-11 items-center justify-center rounded-lg border border-gray-300 text-brand-gray transition-colors duration-200 hover:bg-gray-100"
                >
                    <FaArrowLeft />
                </button>
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 rounded-lg bg-brand-400 px-6 py-2.5 font-semibold text-white transition-colors duration-300 hover:bg-brand-500"
                >
                    <FaHome />
                    {t('navbar.home')}
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
